import upm from './client';
import { fetchAPI } from '../utils';
const opts = {
    headers: {
        Accept: 'application/vnd.synchronoss.upm-1.0+json',
        'Content-Type': 'application/vnd.synchronoss.upm-1.0+json',
    },
};
const apiType = 'upm';
export const fetchApi = async (params, endpoint, logger) => {
    logger ? upm.setLogger(logger) : undefined;
    return fetchAPI(`/${endpoint}`, apiType, params, opts.headers);
};
export const postApi = async (body, endpoint, logger) => {
    logger ? upm.setLogger(logger) : undefined;
    return upm.post(`/${endpoint}`, apiType, { data: body, ...opts });
};
export const putApi = async (body, hashCode, endpoint, logger) => {
    logger ? upm.setLogger(logger) : undefined;
    return upm.put(`/${endpoint}`, apiType, {
        data: body,
        ...opts,
        headers: { ...opts.headers, 'If-Match': hashCode },
    });
};
export const uploadApi = async (method, data, endpoint, headers, logger) => {
    logger ? upm.setLogger(logger) : undefined;
    const form = new FormData();
    Object.entries(data).forEach(([key, value]) => form.append(key, value));
    return upm[method](`/${endpoint}`, apiType, {
        data: form,
        headers,
    });
};
